export default `
  mutation createGitHubRepo($login: String!, $repo: String!, $description: String, $isPrivate: Boolean) {
    createGitHubRepo(login: $login, repo: $repo, description: $description, isPrivate: $isPrivate) {
      success
      resData {
        id
        name
        full_name
        private
        owner {
          login
          avatar_url
        }
        html_url
        description
      }
      errorText
    }
  }
`
